import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Dashbord from '../../Moduls/Dashbord';
import CashoutManager from './CashoutManager';
import { store } from './CashoutManagerUtils';

const CashoutManagerModule = ({ match }) => {
  return (
    <main className="efb-main">
      <section className="efb-container">
        <Switch>
          <Route
            path={`${match.path}/:module`}
            render={props => <CashoutManager {...props} />}
          />
          <Route
            path={`${match.path}/:moduleId`}
            render={() => <Dashbord items={store.dashboard} />}
          />
          <Route
            path={match.path}
            render={() => <Dashbord items={store.dashboard} />}
          />
        </Switch>
      </section>
    </main>
  );
};

export default CashoutManagerModule;
